import React, { memo } from 'react';

import LabelCDS from '@sharedCR/coreDesignSystem/LabelCDS';
import { LabelSize, LabelVariant } from '@sharedCR/coreDesignSystem/LabelCDS/LabelCDS.constants';
import PropTypes from 'prop-types';

import { FormDeliveryReadinessStatus } from 'constants/loanApplication';

const statusToVariant = {
  [FormDeliveryReadinessStatus.PENDING]: LabelVariant.ORANGE,
  [FormDeliveryReadinessStatus.REJECTED]: LabelVariant.RED,
};

const FormDeliveryReadinessChip = ({ status }) => {
  const variant = statusToVariant[status];

  if (!variant) {
    return null;
  }

  return <LabelCDS size={LabelSize.S} title={status} variant={variant} />;
};

FormDeliveryReadinessChip.propTypes = {
  status: PropTypes.string,
};

export default memo(FormDeliveryReadinessChip);
